const Getters = {
  hasOwnerRights(state, getters, rootState, rootGetters) {
    const hasDevRights = () => rootGetters['auth/inDevMode']
    const isOwner = () => state.selectedReport && state.selectedReport.ownerId === rootGetters['auth/userEmail']

    return hasDevRights() || isOwner()
  },
  isEditor(state, getters, rootState, rootGetters) {
    const userEmail = rootGetters['auth/userEmail']
    const { selectedReport } = state
    return userEmail && selectedReport && selectedReport.roles && selectedReport.roles.find((role) => role.userId === userEmail && role.role === 'editor')
  },
  hasEditorRights(state, getters, rootState, rootGetters) {
    const hasInternalRights = () => rootGetters['auth/isInternalUser']
    const hasEditorRights = () => getters.isEditor

    return getters.hasOwnerRights || hasInternalRights() || hasEditorRights()
  },
}

export default Getters
